/* lua.js generated code 0.3.0 */
require("clover/data/ItemDataManager")
var UserDealPayTypeBase = require("clover/logic/userDeal/UserDealPayTypeBase")
var UserDealPayTypeCash = xClass("UserDealPayTypeCash", UserDealPayTypeBase)
UserDealPayTypeCash.prototype.canBuyGoods = function (goodsId, num) {
    var self = this
    var goodsMeta = MetaManager.getInstance().getGoodsMeta(goodsId)
    if (goodsMeta.qCash === 0) {
        return [false, ZooErrorCode.BUY_WRONG_MONEY_TYPE]
    }
    var price = goodsMeta.qCash
    if (goodsMeta.discountQCash !== 0) {
        price = goodsMeta.discountQCash
    }
    if (UserCash.getInstance().getAvaliableCash() < price * num) {
        return [false, ZooErrorCode.CASH_NOT_ENOUGH]
    }
    return [true,null]
}
UserDealPayTypeCash.prototype.buyGoods = function (goodsId, num, targetId, param, successCallback, failCallback, cancelCallback) {
    var self = this
    var goodsMeta = MetaManager.getInstance().getGoodsMeta(goodsId)
    var price = goodsMeta.qCash
    if (goodsMeta.discountQCash !== 0) {
        price = goodsMeta.discountQCash
    }
    function onSuccess(event) {
        UserCash.getInstance().unlockCash(price * num)
        UserCash.getInstance().consumeCash(price * num)
        if (successCallback) {
            successCallback(event)
        }
    }
    function onFail(event) {
        UserCash.getInstance().unlockCash(price * num)
        if (failCallback) {
            failCallback(event)
        }
    }
    function onCancel() {
        UserCash.getInstance().unlockCash(price * num)
        if (cancelCallback) {
            cancelCallback()
        }
    }
    UserCash.getInstance().lockCash(price * num)
    var http
    if (goodsMeta.online) {
        http = BuyOnlineHttp.new(true)
    } else {
        http = BuyHttp.new(true)
    }
    let time = param ? param.time : null
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load(goodsId, num, 2, targetId,time)
}
/**
 * 检查指定编号的Item是否可以购买
 */
UserDealPayTypeCash.prototype.canBuyItem = function (itemId, num) {
    var self = this
    var itemData = ItemDataManager.getItemDataById(itemId)
    if (itemData.payType !== ItemDataManager.PayTypeEnum.Cash) {
        return [false, ZooErrorCode.BUY_WRONG_MONEY_TYPE]
    }
    var price = itemData.price
    // if (goodsMeta.discountQCash !== 0) {
    //     price = goodsMeta.discountQCash
    // }
    if (UserCash.getInstance().getAvaliableCash() < price * num) {
        return [false, ZooErrorCode.CASH_NOT_ENOUGH]
    }
    return [true, null]
}
/**
 * 购买指定编号的Item
 */
UserDealPayTypeCash.prototype.buyItem = function (itemId, num, successCallback, failCallback, cancelCallback) {
    var self = this
    var itemData = ItemDataManager.getItemDataById(itemId)
    var price = itemData.price
    // if (goodsMeta.discountQCash !== 0) {
    //     price = goodsMeta.discountQCash
    // }
    function onSuccess(event) {
        UserCash.getInstance().unlockCash(price * num)
        UserCash.getInstance().consumeCash(price * num)
        if (successCallback) {
            successCallback(event)
        }
    }
    function onFail(event) {
        UserCash.getInstance().unlockCash(price * num)
        if (failCallback) {
            failCallback(event)
        }
    }
    function onCancel() {
        UserCash.getInstance().unlockCash(price * num)
        if (cancelCallback) {
            cancelCallback()
        }
    }
    UserCash.getInstance().lockCash(price * num)
    var http = StartPanelBuyPropHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load(itemId, num)
}
module.exports = UserDealPayTypeCash
